import { SINGLE_ACTION_DISPATCHED } from "./actionTypes";

export const singleActionDispatched = (actionType) => {
  return {
    type: SINGLE_ACTION_DISPATCHED,
    payload: actionType
  };
}